<nz-row [nzJustify]="'center'">
  <nz-col
    [nzLg]="{ span: 12, offset: 0 }"
    [nzMd]="{ span: 18, offset: 0 }"
    [nzSm]="{ span: 22, offset: 0 }"
    [nzXs]="{ span: 22, offset: 0 }">
    <article nz-typography>
      <h1 i18n="@@page-terms-and-conditions-content-title" nz-typography>
        Terms and Conditions for Ig4u
      </h1>
      <p i18n="@@page-terms-and-conditions-content-paragraph-0" nz-typography>
        Welcome to <strong>Ig4u</strong> (Service), a service that allows users
        to view Instagram accounts anonymously for non-commercial purposes.
        Before using our service, please read the following terms and conditions
        carefully.
      </p>
      <nz-divider></nz-divider>
      <h2
        i18n="
          @@page-terms-and-conditions-content-acceptance-of-terms-section-title"
        nz-typography>
        Acceptance of Terms
      </h2>
      <uL>
        <li>
          <p
            i18n="
              @@page-terms-and-conditions-content-acceptance-of-terms-section-paragraph-0"
            nz-typography>
            By using Service (accessible at
            <a [routerLink]="'/'">https://ig4u.co</a>), you agree to comply with
            and be bound by these terms and conditions. If you do not agree with
            any part of these terms, you may not use our service.
          </p>
        </li>
      </uL>
      <nz-divider></nz-divider>
      <h2
        i18n="@@page-terms-and-conditions-content-use-of-service-section-title"
        nz-typography>
        Use of Service
      </h2>
      <ul>
        <li>
          <p
            i18n="
              @@page-terms-and-conditions-content-use-of-service-section-paragraph-0"
            nz-typography>
            Service is intended for personal, non-commercial use only. You may
            use our service to view Instagram accounts and their content,
            provided that you do not use the content for any commercial
            purposes.
          </p>
        </li>
      </ul>
      <nz-divider></nz-divider>
      <h2
        i18n="
          @@page-terms-and-conditions-content-intellectual-property-section-title"
        nz-typography>
        Intellectual Property
      </h2>
      <ul>
        <li>
          <p
            i18n="
              @@page-terms-and-conditions-content-intellectual-property-section-paragraph-0"
            nz-typography>
            All rights to the content viewed through Service belong to the
            respective content creators, including but not limited to images,
            videos, text, and any other materials. You may not reproduce,
            distribute, modify, or create derivative works from this content
            without the explicit permission of the content owner.
          </p>
        </li>
      </ul>
      <nz-divider></nz-divider>
      <h2
        i18n="
          @@page-terms-and-conditions-content-prohibited-activities-section-title"
        nz-typography>
        Prohibited Activities
      </h2>
      <p
        i18n="
          @@page-terms-and-conditions-content-prohibited-activities-section-paragraph-0"
        nz-typography>
        You agree not to engage in any of the following activities while using
        Service:
      </p>
      <ul>
        <li>
          <p
            i18n="
              @@page-terms-and-conditions-content-prohibited-activities-section-paragraph-1"
            nz-typography>
            Violating any laws or regulations.
          </p>
        </li>
        <li>
          <p
            i18n="
              @@page-terms-and-conditions-content-prohibited-activities-section-paragraph-2"
            nz-typography>
            Infringing upon the intellectual property rights of others.
          </p>
        </li>
        <li>
          <p
            i18n="
              @@page-terms-and-conditions-content-prohibited-activities-section-paragraph-3"
            nz-typography>
            Interfering with the proper functioning of Service.
          </p>
        </li>
        <li>
          <p
            i18n="
              @@page-terms-and-conditions-content-prohibited-activities-section-paragraph-4"
            nz-typography>
            Using Service for illegal or unauthorized purposes.
          </p>
        </li>
      </ul>
      <nz-divider></nz-divider>
      <h2
        i18n="
          @@page-terms-and-conditions-content-disclaimer-of-warranties-section-title"
        nz-typography>
        Disclaimer of Warranties
      </h2>
      <ul>
        <li>
          <p
            i18n="
              @@page-terms-and-conditions-content-disclaimer-of-warranties-section-paragraph-0"
            nz-typography>
            Service is provided on an "as is" and "as available" basis without
            warranties of any kind, express or implied. We do not guarantee the
            accuracy, completeness, or reliability of any content accessed
            through our
          </p>
        </li>
      </ul>
      <nz-divider></nz-divider>
      <h2
        i18n="
          @@page-terms-and-conditions-content-limitation-of-liability-section-title"
        nz-typography>
        Limitation of Liability
      </h2>
      <ul>
        <li>
          <p
            i18n="
              @@page-terms-and-conditions-content-limitation-of-liability-section-paragraph-0"
            nz-typography>
            Service, its affiliates, and partners shall not be liable for any
            indirect, incidental, special, or consequential damages arising out
            of or in connection with the use of our service.
          </p>
        </li>
      </ul>
      <nz-divider></nz-divider>
      <h2
        i18n="
          @@page-terms-and-conditions-content-changes-to-terms-section-title"
        nz-typography>
        Changes to Terms
      </h2>
      <ul>
        <li>
          <p
            i18n="
              @@page-terms-and-conditions-content-changes-to-terms-section-paragraph-0"
            nz-typography>
            Service reserves the right to modify or update these terms and
            conditions at any time without prior notice. It is your
            responsibility to review these terms periodically for any changes.
          </p>
        </li>
      </ul>
      <nz-divider></nz-divider>
      <h2
        i18n="@@page-terms-and-conditions-content-governing-law-section-title"
        nz-typography>
        Governing Law
      </h2>
      <ul>
        <li>
          <p
            i18n="
              @@page-terms-and-conditions-content-governing-law-section-paragraph-0"
            nz-typography>
            These terms and conditions shall be governed by and construed in
            accordance with the laws of Georgia, without regard to its conflict
            of law principles.
          </p>
        </li>
      </ul>
      <nz-divider></nz-divider>
      <h2
        i18n="@@page-terms-and-conditions-content-for-eu-users-section-title"
        nz-typography>
        For European Union (EU) users
      </h2>
      <ul>
        <li>
          <p
            i18n="
              @@page-terms-and-conditions-content-for-eu-users-section-paragraph-0"
            nz-typography>
            If You are a European Union consumer, you will benefit from any
            mandatory provisions of the law of the country in which you are
            resident in.
          </p>
        </li>
      </ul>
      <nz-divider></nz-divider>
      <h2
        i18n="
          @@page-terms-and-conditions-content-us-legal-compliance-section-title"
        nz-typography>
        United States Legal Compliance
      </h2>
      <ul>
        <li>
          <p
            i18n="
              @@page-terms-and-conditions-content-us-legal-compliance-section-paragraph-0"
            nz-typography>
            You represent and warrant that (i) You are not located in a country
            that is subject to the United States government embargo, or that has
            been designated by the United States government as a "terrorist
            supporting" country, and (ii) You are not listed on any United
            States government list of prohibited or restricted parties.
          </p>
        </li>
      </ul>
      <nz-divider></nz-divider>
      <h2
        i18n="
          @@page-terms-and-conditions-content-contact-information-section-title"
        nz-typography>
        Contact Information
      </h2>
      <ul>
        <li>
          <p
            i18n="
              @@page-terms-and-conditions-content-contact-information-section-paragraph-0"
            nz-typography>
            If you have any questions or concerns about these terms and
            conditions, please contact us at <strong>hello&#64;ig4u.co</strong>.
          </p>
        </li>
      </ul>
    </article>
  </nz-col>
</nz-row>
